import React from 'react';
import Back from '@sats-group/icons/24/back';
import LinkButton from '@sats-group/fresh-fitness-ui-lib/react/link-button';
import Text from '@sats-group/fresh-fitness-ui-lib/react/text';

import ContentContainer from 'root/client/components/content-container/content-container';
import Layout from 'root/client/components/layout/layout';
import Map from 'root/client/components/map/map';

import type { ClubsMapPage as Props } from './clubs-map-page.types';

const ClubsMapPage: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  introduction,
  layout,
  list,
  map,
  title,
}) => (
  <Layout {...layout} theme={Layout.themes.Primary}>
    <div className="clubs-map-page">
      <ContentContainer width={ContentContainer.widths.Narrow}>
        <div className="clubs-map-page__title">
          <Text
            elementName="h1"
            size={Text.sizes.header2}
            variant={Text.variants.hero}
          >
            {title}
          </Text>
        </div>
        <div className="clubs-map-page__introduction">
          <Text size={Text.sizes.basic} elementName="p">
            {introduction}
          </Text>
        </div>
        <div className="clubs-map-page__link">
          <LinkButton theme={LinkButton.themes.secondary} {...list} />
        </div>
      </ContentContainer>
      <ContentContainer>
        <div className="clubs-map-page__map">
          <Map {...map} />
          <div className="clubs-map-page__mobile-back-button">
            <LinkButton icon={<Back />} {...list} />
          </div>
        </div>
      </ContentContainer>
    </div>
  </Layout>
);

export default ClubsMapPage;
